module.exports = __webpack_public_path__ + "media/sitemap_page/images/ico_header_top_star-a03764cb9a0f7c79a2944b6f165e5bb7.png";